<template>
  <div>
    <myheader></myheader>
    <van-image :src="require('../assets/img/about_banner.png')"/>
    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">联系我们</h1>
    <hr width="10%" style="border: 1px solid #000;">
    <div class="about_content">
      <p>义乌市伊拉文进出口有限公司</p>
      <p>QQ：1158292145</p>
<!--      <p>7*24联系电话：152 6808 5238</p>-->
      <p>座机：0579-85553367</p>
      <p>地址：地址浙江省义乌市稠州北路999号国贸大厦9楼911室</p>
    </div>

    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">留言板</h1>
    <div class="about_content">
      <van-field v-model="form.name" placeholder="请输入姓名" label-width="2rem" >
        <template #label>
          <van-icon name="user-o" size="28" />
        </template>
      </van-field>
      <van-field v-model="form.phone" placeholder="请输入手机号" label-width="2rem" >
        <template #label>
          <van-icon name="phone-o" size="28" />
        </template>
      </van-field>
      <van-field v-model="form.message" type="textarea" placeholder="请输入内容" label-width="2rem" rows="1" autosize >
        <template #label>
          <van-icon name="comment-o" size="28" />
        </template>
      </van-field>
      <van-button round block type="primary" @click="SubmitMessage">提交</van-button>
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>
import {Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem, Icon} from 'vant'
import {sendMsg} from "@/api";

export default {
  name: 'Contact',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        message: '',
      }
    }
  },
  methods: {
    SubmitMessage() {
      sendMsg(this.form).then(res => {
        this.form.name = ''
        this.form.phone = ''
        this.form.message = ''
        Toast('提交成功！')
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.about_content {
  padding: 1rem 1.5rem 2.1rem;
  font-size: 0.72rem;
  font-weight: normal;
  color: #666666;
  line-height: 1.2rem;
}
</style>
